import { gql } from '@apollo/client'

export const UNIFIED_ONBOARDING_UPSELL_OFFERS = gql`
  query unifiedOnboardingUpsellOffers {
    unifiedOnboardingUpsellOffers {
      upsellOffers {
        kind
        data
        completedText
        skippedText
      }
    }
  }
`
